import script from "./HomepageUnicefbelgique.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepageUnicefbelgique.vue?vue&type=script&setup=true&lang=js"

import "./HomepageUnicefbelgique.vue?vue&type=style&index=0&id=015f2692&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-015f2692"]])

export default __exports__